var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecordIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4739 9.54037C11.4739 9.22279 11.2149 8.96641 10.8967 8.96641C10.5786 8.96641 10.3195 9.22279 10.3195 9.54037C10.3195 11.8034 8.46625 13.6456 6.18688 13.6456C3.90764 13.6456 2.05434 11.8034 2.05434 9.54037C2.05434 9.22279 1.79532 8.96641 1.47717 8.96641C1.15902 8.96641 0.9 9.22279 0.9 9.54037C0.9 12.2441 2.96549 14.4756 5.60971 14.7622V15.848H3.93896C3.6208 15.848 3.36179 16.1044 3.36179 16.422C3.36179 16.7397 3.6208 16.9961 3.93896 16.9961H8.43493C8.75299 16.9961 9.01198 16.7397 9.01198 16.422C9.01198 16.1044 8.75299 15.848 8.43493 15.848H6.76406V14.7623C9.4084 14.4757 11.4739 12.2441 11.4739 9.54037Z",
    fill: "#717171",
    stroke: "#717171",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18701 12.6762C7.92632 12.6762 9.3423 11.2703 9.3423 9.54067V4.0354C9.3423 2.30589 7.92631 0.9 6.18701 0.9C4.44782 0.9 3.03184 2.30589 3.03184 4.0354V9.54067C3.03184 11.2703 4.44782 12.6762 6.18701 12.6762ZM4.18606 4.0354C4.18606 2.9403 5.08317 2.04817 6.18701 2.04817C7.29085 2.04817 8.18796 2.9403 8.18796 4.0354V9.54067C8.18796 10.6358 7.29084 11.528 6.18701 11.528C5.08318 11.528 4.18606 10.6358 4.18606 9.54067V4.0354Z",
    fill: "#717171",
    stroke: "#717171",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordIcon);
export default __webpack_public_path__ + "static/media/record-icon.2f4b2afb7f25e8e6fa98394b202126a0.svg";
export { ForwardRef as ReactComponent };